import { useState, useEffect } from 'react'
import { getTvmazeInfo } from '../lib/tvmaze'

// Given TMDB show objects (each with an id), returns a map tmdbId -> TVmaze info
// (or null when there is no match). Resolution is lazy, cached, and throttled in
// the lib, so this is safe to call with the full watching set on every render.
export function useAirSchedule(shows) {
  const [info, setInfo] = useState({})
  const ids = (shows || []).map(s => s && s.id).filter(Boolean).slice(0, 20)
  const key = ids.slice().sort((a, b) => a - b).join(',')
  useEffect(() => {
    let off = false
    if (!ids.length) return
    ;(async () => {
      // Batch results: one setState per ~5 resolves instead of per show.
      // With several instances mounted (Home greeting / MorningBrief /
      // PremiereNight / UpNext / WeeklySchedule), per-show setState was a
      // re-render drip-feed for seconds after every mount — the whole page
      // re-rendered up to 20× per instance and taps felt laggy meanwhile.
      const buf = {}
      let pending = 0
      const flush = () => {
        if (off || !pending) return
        const batch = { ...buf }
        pending = 0
        setInfo(prev => ({ ...prev, ...batch }))
      }
      for (const id of ids) {
        try {
          const v = await getTvmazeInfo(id)
          if (off) return
          buf[id] = v
          pending++
          if (pending >= 5) flush()
        } catch (e) {}
      }
      flush()
    })()
    return () => { off = true }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
  return info
}
